<template>
  <el-form class="reports-index tasks-page">
    <h3>Задачи</h3>
    <div class="create-new">
      <router-link :to="`/dashboard/tasks/create`" class="add-block">
        <el-button type="primary"> + Создать</el-button>
      </router-link>
    </div>
    <div class="search-filter">
      <el-input placeholder="Поиск по номеру задачи" v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="filter-worker">
        <!--        <el-popover-->
        <!--          placement="right"-->
        <!--          width="400"-->
        <!--          trigger="click">-->
        <!--          <div>-->
        <!--            hello-->
        <!--          </div>-->
        <!--          <el-button slot="reference" style="width: 100%">Фильтра</el-button>-->
        <!--        </el-popover>-->
        <el-dialog
          title="Фильтры"
          :visible.sync="dialogVisible"
        >
          <div>
            <filter-select v-model="filter.status" @input="changeStatus" label="Статус задачи" :options="[
              {
              label: 'Показать все',
              value: null,
            },
              {
              label: 'Без статуса',
              value: '',
            },
              {
              label: 'В работе',
              value: 'IN_PROGRESS',
            },
            {
              label: 'Выполнено',
              value: 'IN_TEST',
            },
            {
              label: 'Принято',
              value: 'DONE',
            },
            {
              label: 'Просрочено',
              value: 'DEADLINE',
            }
            ]">
            </filter-select>
            <filter-select v-model="filter.executor" label="Исполнитель" :options="options.users">

            </filter-select>
            <filter-select v-model="filter.user" label="Создатель" :options="options.users">

            </filter-select>
            <filter-select v-model="filter.object" label="Объект" :options="options.objects">

            </filter-select>
            <filter-select v-model="filter.category" label="Категория" :options="options.categories">
            </filter-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Ок</el-button>
          </span>
        </el-dialog>
        <el-button slot="reference" style="width: 100%" @click="dialogVisible = true">Фильтры</el-button>
      </div>
      <div class="filter">
        <date-picker
          :editable="false"
          v-if="render"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="datetimeRange"
          @change="changeDateTime"
          range
        ></date-picker>

      </div>
      <a
        @click="openDialog = true"
        class="filter-btn"
      >
        <el-button type="default">Выгрузить</el-button>
      </a>
    </div>
    <div class="reports-ul">
      <router-link
        :to="`/dashboard/tasks/create/${report.id}`"
        :key="report.id"
        class="reports-li" v-for="report in filteredReports"
      >
        <div class="header-id">
          <span>#{{ report.index }}</span>
          <span>{{ report.date }}</span>
        </div>
        <span><strong>{{ report.title }}</strong></span>
        <span>Автор: <strong>{{ report.user.name }}</strong></span>
        <span>Назначено: <strong>{{ report.executor && report.executor.name }}</strong></span>
        <span>Категория: <strong>{{ report.category && report.category.name }}</strong></span>
        <span>Статус: <strong>{{ (report.status && report.status.label) || 'Без статуса' }}</strong></span>

      </router-link>
    </div>


    <el-dialog
      title="Выгрузить отчет"
      :visible.sync="openDialog"
      width="30%"
      center
    >
      <div v-if="!typeSelect" class="select-container">
        <div class="btn-container">
          <el-button type="default" @click="typeSelect = 'default'">Реестр задач</el-button>
        </div>
        <div class="btn-container">
          <el-button type="default" @click="typeSelect = 'report'">Отчет по задачам</el-button>
        </div>
      </div>
      <div v-else>
        <div>
          <div>
            <date-picker
              :editable="false"
              ref="datePicker"
              placeholder="Фильтр по дате"
              v-model="datetimeRangeDownload"
              range
            ></date-picker>
            <el-row>
              <el-col :span="12">
                <el-checkbox v-model="downloadForAll" style="margin-top: 10px">За все время</el-checkbox>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-form v-if="typeSelect === 'report'">
          <filter-select
            v-model="filter.group"
            label="Порядок групировки"
            multiple
            :options="groupOptions"
          />
        </el-form>

        <span slot="footer" class="dialog-footer" style="margin-top: 24px">
          <el-button @click="closeDialog" style="margin-right: 8px">Закрыть</el-button>
          <a :href="getHref" target="_blank">
            <el-button type="primary" @click="closeDialog">Выгрузить</el-button>
          </a>
        </span>
      </div>
    </el-dialog>
  </el-form>
</template>

<script>
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import _ from 'lodash';
import {apiUrl, isApiRuleIgnore} from '../../../plugins/firebase';
import {formatEndDate, formatStartDate} from "../../../utils/date";
import {getMyCompanyUsers, getPermissionByUser} from "../../../firestore/permission";
import AddObject from "../Documentation/components/AddObject";
import FilterSelect from "../../../components/FilterSelect";
import {getUsersOptions} from "../../../firestore/users";
import {getObjectOptions} from "../../../firestore/objects";
import {getOptionsTasksCategories} from "../../../firestore/tasks-categories";

export default {
  name: 'Index',
  components: {FilterSelect, AddObject, DatePicker},
  data() {
    return {
      openDialog: false,
      search: '',
      role: 'admin',
      typeSelect: null,
      userSelect: null,
      dialogVisible: false,
      init: false,
      render: true,
      options: {
        users: [],
        objects: [],
        categories: [],
      },
      groupOptions: [{
        label: 'Объект',
        value: 'object'
      }, {
        label: 'Категория',
        value: 'category'
      },
        {
          label: 'Исполнитель',
          value: 'executor'
        },],
      filter: {
        object: '',
        executor: '',
        user: '',
        group: [],
        status: {
          label: "В работе",
          value: "IN_PROGRESS"
        },
      },
      type_select: null,
      datetimeRange: [
        null,
        null,
      ],
      downloadForAll: false,
      downloadWithPrice: false,
      datetimeRangeDownload: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
      reports: [],
    };
  },

  async mounted() {
    if (!this.$store.state.project.version) {
      this.permission = await getPermissionByUser(this.$store.state.project.id, authFirestore.currentUser.uid, this.$store.state.project.plan);
    }

    const filters = localStorage.getItem('filters_' + this.$store.state.project.id);
    let query = {}

    if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
      query.plan = this.$store.state.project.plan.id;
    }

    this.objects = await getObjectOptions(this.$store.state.project.id, this.permission, query);

    if (filters) {
      this.filter = JSON.parse(filters);
      if (!this.filter) {
        this.filter.status = {
          label: "В работе",
          value: "IN_PROGRESS"
        }
      }
      this.changeStatus();
    }

    setTimeout(() => this.init = true, 3000);


    if (this.$route.query.start) {
      this.datetimeRange = [
        new Date(String(this.$route.query.start)),
        new Date(String(this.$route.query.end)),
      ];
    } else if (this.$store.state.project.disableDate) {
      this.datetimeRange = [
        new Date(String(dayjs().subtract(365 * 5, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().add(365 * 5, 'days').format('YYYY-MM-DD'))),
      ];
    }

    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).get().then(async (sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[authFirestore.currentUser.uid];
          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
      setTimeout(() => {
        this.fetchReports();
        this.fetchUsers();
        this.fetchCategories();
        this.fetchObjects();
      }, 200)
    });
  },

  watch: {
    '$route.query': {
      handler(response) {
        this.fetchReports();
      },
      deep: true,
    },
    type_select() {
      this.datetimeRangeDownload = [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ]
    }
  },

  methods: {
    changeStatus() {
      if (this.filter.status.value === 'DEADLINE') {
        localStorage.setItem('datetimefilter', JSON.stringify(this.datetimeRange))
        setTimeout(() => {
          this.datetimeRange = [
            null,
            null,
          ]
          this.changeDateTime()
        });
      } else if (this.datetimeRange[0] === null) {
        const date = localStorage.getItem('datetimefilter');
        if (date) {
          this.datetimeRange = JSON.parse(date);
          this.datetimeRange = [
            new Date(this.datetimeRange[0]),
            new Date(this.datetimeRange[1]),
          ];
          setTimeout(() => {
            localStorage.removeItem('datetimefilter');
            this.changeDateTime()
          }, 200)
        }
      }
    },
    closeDialog() {
      setTimeout(() => {
        this.openDialog = false;
        this.typeSelect = null;
      }, 1000);
    },
    selectUser() {
      let query = {
        ...this.$route.query,
      };
      if (!this.userSelect) {
        delete query.user;
      } else {
        query = {
          ...this.$route.query,
          user: this.userSelect,
        };
      }

      this.$router.push({
        path: this.$route.path,
        query: {
          ...query,
        },
      });
    },
    async fetchUsers() {
      this.loader = true;

      this.options.users = await getUsersOptions(this.$store.state.project.id);
      this.loading = false;
    },
    async fetchCategories() {
      this.loader = true;

      this.options.categories = await getOptionsTasksCategories(this.$store.state.project.id);

      this.loading = false;
    },
    async fetchObjects() {
      this.loader = true;

      this.options.objects = await getObjectOptions(this.$store.state.project.id);

      this.loading = false;
    },
    changeDateTime() {
      if (this.datetimeRange[0] && this.datetimeRange[1]) {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            start: dayjs(this.datetimeRange[0]).format('YYYY-MM-DD'),
            end: dayjs(this.datetimeRange[1]).format('YYYY-MM-DD'),
          },
        });
      } else {
        const query = {...this.$route.query};
        delete query.start;
        delete query.end;
        this.$router.push({
          path: this.$route.path,
          query: {
            ...query
          },
        });
        this.fetchReports();
      }
    },
    sendReport() {
      // const proxy = firebase.functions().httpsCallable(`onGenerateLogCommonJobs/${this.$store.state.project.id}`);
      // proxy().then(() => {
      //   this.$notify({
      //     offset: 60,
      //
      //     title: 'Успешно!',
      //     message: 'Отчет отправлен вам на почту',
      //     type: 'success',
      //   });
      // }).catch(() => {
      //   this.$notify({
      //     offset: 60,
      //
      //     title: 'Ошибка',
      //     message: 'Произошла ошибка, попробуйте позже',
      //     type: 'error',
      //   });
      // });
    },
    navigate(report) {
      this.$router.push(
        `/dashboard/reports/edit/${report.id}/${this.$route.params.type}`,
      );
    },
    fetchReports: async function () {
      let query = myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('tasks');

      const filterArray = [];

      if (this.search) {
        filterArray.push(
          ['index', '==', Number(this.search)],
        );
      }

      if (this.$route.query.start && this.$route.query.end) {
        filterArray.push(
          ['deadline_dateunix', '<', formatEndDate(this.$route.query.end)],
        );
        filterArray.push(
          ['deadline_dateunix', '>', formatStartDate(this.$route.query.start)],
        );
      } else if (this.datetimeRange[1] && this.datetimeRange[0]) {
        filterArray.push(
          ['deadline_dateunix', '<', formatEndDate(this.datetimeRange[1])],
        );
        filterArray.push(
          ['deadline_dateunix', '>', formatStartDate(this.datetimeRange[0])],
        );
      }

      query = filterArray.reduce((accQuery, filter) => {
        return accQuery.where(filter[0], filter[1], filter[2]);
      }, query).orderBy('deadline_dateunix', 'desc');


      query.get()
        .then(async (data) => {
          const result = [];
          this.reports = [];
          data.forEach((subDoc) => {
            const data = subDoc.data();

            if (this.permission && this.permission.available_objects) {

              const objects = this.permission.available_objects
              const notifications = (data.notifications || []).map(({value}) => value)
              if (notifications.includes(authFirestore.currentUser.uid)) {
              } else if ((!data.object || !data.object.id) && objects.includes('all')) {

              } else if ((!data.object || !data.object.id || !objects.includes(data.object.id))) {
                return
              }
            }

            result.push({
              ...data,
              index: data.index,
              id: subDoc.id,
              object: data.object && data.object.name,
              objectId: data.object && data.object.id,
              date: dayjs(data.deadline_datetime.substring(0, data.deadline_datetime.indexOf('+'))).format('DD/MM/YY'),
              jobs: data.jobs,
            });
          });

          console.log(result, 'result')

          let final_result = [];
          // if (this.role === 'editor') {
          //   const usersIds = await getMyCompanyUsers(this.$store.state.project.id);
          //   final_result = result.filter((r) => usersIds.includes(r.userId) || usersIds.includes(r.executor.id));
          //   console.log(usersIds, 'usersIds')
          // } else {
          final_result = result;
          // }

          this.reports = _.orderBy(final_result, 'deadline_dateunix', ['asc']);
        });
    },
  },
  computed: {
    filteredReports() {
      // filter: {
      //     object: '',
      //     executor: '',
      //     user: '',
      //     category: '',
      //     status: '',
      // }

      if (this.init) {
        localStorage.setItem('filters_' + this.$store.state.project.id, JSON.stringify(this.filter))
      }

      return this.reports.filter((report) => {
        if (this.filter.status && this.filter.status.value && this.filter.status.value !== 'DEADLINE') {
          if ((report.status && report.status.value) !== this.filter.status.value) {
            return false;
          }
        }

        if (this.filter.status && this.filter.status.value === '') {
          if (report.status !== '') {
            return false;
          }
        }

        if (this.filter.status && this.filter.status.value === 'DEADLINE') {
          if ((report.status && report.status.value) === 'DONE' || (report.status && report.status.value) === 'IN_TEST') {
            return false
          }

          // if(report.status && (report.status.value === 'DONE' || report.status.value === 'IN_TEST')) {
          //   if(isNaN(report.finish_dateunix)) {
          //     return false
          //   }
          //
          //   if(dayjs(report.deadline_dateunix * 1000).add(1, 'days').unix() > report.finish_dateunix) {
          //     return false
          //   }
          //   return true
          // }

          if (dayjs(report.deadline_dateunix * 1000).add(1, 'days').unix() > dayjs().unix()) {
            return false
          }
        }

        const notifications = (report.notifications || []).map(({value}) => value)
        if (notifications.includes(authFirestore.currentUser.uid)) {
          return true
        }

        if (this.role === 'worker') {
          if (((report.executor || {}).id !== authFirestore.currentUser.uid && report.userId !== authFirestore.currentUser.uid)) {
            return false
          }
        }

        if (this.filter.object && this.filter.object.value) {
          if (report.objectId !== this.filter.object.value) {
            return false;
          }
        }

        if (this.filter.executor && this.filter.executor.value) {
          if (report.executor.id !== this.filter.executor.value) {
            return false;
          }
        }

        if (this.filter.user && this.filter.user.value) {
          if (report.userId !== this.filter.user.value) {
            return false;
          }
        }

        if (this.filter.category && this.filter.category.value) {
          if (report.category.id !== this.filter.category.value) {
            return false;
          }
        }


        if (this.search) {
          return report.index == this.search
        }

        return true

      });
    },
    getHref() {

      if(this.typeSelect === 'report') {
        const fromDate = dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')
        const toDate = dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')
        const project = this.$store.state.project.id;
        const uid = this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid


        let url = `${apiUrl}/onGenerateTasksReports%3FprojectId%3D${project}%26uid%3D${uid}`

        if(!this.downloadForAll) {
          url += `%26fromDate%3D${fromDate}%26toDate%3D${toDate}`
        }

        if(this.filter.group && this.filter.group.length) {
          url += `%26order=${this.filter.group.map(({value}) => value).join(',')}`
        }

        if(isApiRuleIgnore) {
          url = decodeURIComponent(url)
        }

        return url
      }

      const path = 'onGenerateTasks';
      const params = encodeURIComponent(`/${path}/${this.$store.state.project.id}`)

      let url = `${apiUrl}${params}&queryParams=uid=${authFirestore.currentUser.uid}`;
      if (!this.downloadForAll) {
        url += `, fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}, toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;
      }

      if(isApiRuleIgnore) {
        url = decodeURIComponent(url)
      }


      return url;
    },
  },
};
</script>
<style lang="scss">
.tasks-page {
  .el-date-editor--daterange.el-input__inner {
    width: 100%;
    margin-top: 10px;
  }

  .mx-datepicker-range {
    width: 100%;
    margin-top: 10px;

    .mx-input {
      border: 1px solid #DCDFE6;
      height: 40px;
    }
  }
}

</style>

<style scoped lang="scss">
.select-container {
  display: flex;
  flex-direction: column;
}

.btn-container {
  display: flex;
  justify-content: center;
  flex: 1;

  button {
    margin-bottom: 8px;
    width: 100%;
  }
}

.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.input-search {
  margin-top: 10px;
}

.reports-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  cursor: pointer;
  padding: 10px 14px;
  text-decoration: none;
  color: #000;
  @media screen and (max-width: 764px) {
    width: 92%;

  }

  .header-id {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    width: 100%;

    span:last-child {
      text-align: right !important;
    }
  }

  span {
    font-size: 14px;
    color: #2c3e50;
    width: 100%;
    text-align: left;
  }

  span:first-child {
    margin-right: 20px;
  }


  span {
    margin-right: 5px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

.add-block {
  button {
    width: 100%;
    margin-top: 10px;
  }
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 260px;

  .input-search {
    margin-right: 10px;
    min-width: 260px;
  }

  .filter-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
}

.create-new {
  display: flex;
  justify-content: flex-start;
  flex: 1;
}

.jobs-list {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 764px) {
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: 100%;

    .el-select {
      width: 100%;
    }
  }
}

.create-new {
  display: flex;
  justify-content: space-between;
}

.dialog-footer {
  display: flex;
}

.filter {
  min-width: 260px;
}

.filter-worker {
  min-width: 200px;
  margin-top: 10px;
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Tasks/List.vue